const { over } = require("lodash");

// window.addEventListener('resize', function (event) {
//   $('.easyWizardElement').each(function () {
//     $('.easyWizardWrapper').find('.step').css({
//       'width': $(this).width()
//     });

//     // find the active step and set the margin-left of the wrapper to -1 * width * (step - 1)
//     let step = $(this).find('.step.active').attr('data-step');
//     let width = $(this).width();
//     $(this).find('.easyWizardWrapper').css({
//       'margin-left': width * (step - 1) * -1
//     });
//     // set the height of the active step to auto
//     $(this).find('.step.active').css({
//       'height': 'auto'
//     });
//   });
// }, true);

(function ($) {
  var arrSettings = [];
  var easyWizardMethods = {
    init: function (options) {
      var settings = $.extend({
        'stepClassName': 'step',
        'stepsContainer': '',
        'showSteps': true,
        'stepsText': '{n}. {t}',
        'stepTitleContainer': '',
        'showButtons': true,
        'buttonsClass': '',
        'prevButton': '< Back',
        'nextButton': 'Next >',
        'debug': false,
        'submitButton': true,
        'submitButtonText': 'Submit',
        'submitButtonClass': '',
        before: function (wizardObj, currentStepObj, nextStepObj) { },
        after: function (wizardObj, prevStepObj, currentStepObj) { },
        beforeSubmit: function (wizardObj) {
          wizardObj.find('input, textarea').each(function () {
            if (!this.checkValidity()) {
              this.focus();
              step = $(this).parents('.' + thisSettings.stepClassName).attr('data-step');
              easyWizardMethods.goToStep.call(wizardObj, step);

              return false;
            }
          });
        }
      }, options);

      arrSettings[this.index()] = settings;

      // add listener to window resize
      $(window).on('resize.easyWizard', function () {
        easyWizardMethods.resizeSteps();
      });

      return this.each(function () {
        thisSettings = settings;

        $this = $(this); // Wizard Obj
        $this.addClass('easyWizardElement');
        $steps = $this.find('.' + thisSettings.stepClassName);
        thisSettings.steps = $steps.length;
        thisSettings.width = $(this).width();

        if (thisSettings.steps > 1) {
          // Create UI
          $this.wrapInner('<div class="easyWizardWrapper" />');
          // $this.find('.easyWizardWrapper').width(thisSettings.width * thisSettings.steps);
          $this.find('.easyWizardWrapper').css({
            'height': '100%',
            // 'overflow': 'hidden scroll',
            'display': 'flex',
          });
          $this.css({
            'position': 'relative',
            'overflow': 'hidden'
          }).addClass('easyPager');

          $stepsHtml = $('<ul class="easyWizardSteps">');

          $steps.each(function (index) {
            step = index + 1;
            $(this).css({
              // 'float': 'left',
              'width': thisSettings.width <= 0 ? '100%' : thisSettings.width,
              // 'width': '100%',
              'flex': '0 0 auto',
              'padding': '0 10px',
              // 'height': '1px'
            }).attr('data-step', step);

            if (!index) {
              $(this).addClass('active'); //.css('height', '');
            } else {
              $(this).find('input, textarea, select, button').attr('tabindex', '-1');
            }

            stepText = thisSettings.stepsText.replace('{n}', '<span>' + step + '</span>');
            stepText = stepText.replace('{t}', $(this).attr('data-step-title'));
            $stepsHtml.append('<li' + (!index ? ' class="current"' : '') + ' data-step="' + step + '">' + stepText + '</li>');
          });
          if (thisSettings.stepTitleContainer !== '') {
            $(thisSettings.stepTitleContainer).text($($steps[0]).attr('data-step-title'));
          }

          if (thisSettings.showSteps) {
            if (thisSettings.stepsContainer !== '') {
              $stepsHtml.appendTo(thisSettings.stepsContainer);
            } else {
              $this.prepend($stepsHtml);
            }
          }

          if (thisSettings.showButtons) {
            paginationHtml = '<div class="easyWizardButtons">';
            paginationHtml += '<button class="prev ' + thisSettings.buttonsClass + '">' + thisSettings.prevButton + '</button>';
            paginationHtml += '<button class="next ' + thisSettings.buttonsClass + '">' + thisSettings.nextButton + '</button>';
            paginationHtml += thisSettings.submitButton ? '<button type="submit" class="submit ' + thisSettings.submitButtonClass + '">' + thisSettings.submitButtonText + '</button>' : '';
            paginationHtml += '</div>';
            $paginationBloc = $(paginationHtml);
            $paginationBloc.css('clear', 'both');
            $paginationBloc.find('.prev, .submit').hide();
            $paginationBloc.find('.prev').bind('click.easyWizard', function (e) {
              e.preventDefault();

              $wizard = $(this).parents('.easyWizardElement');
              easyWizardMethods.prevStep.apply($wizard);
            });

            $paginationBloc.find('.next').bind('click.easyWizard', function (e) {
              e.preventDefault();

              $wizard = $(this).parents('.easyWizardElement');
              easyWizardMethods.nextStep.apply($wizard);
            });
            $this.append($paginationBloc);
          }

          $formObj = $this.is('form') ? $this : $(this).find('form');

          // beforeSubmit Callback
          $this.find('[type="submit"]').bind('click.easyWizard', function (e) {
            $wizard = $(this).parents('.easyWizardElement');
            var beforeSubmitValue = thisSettings.beforeSubmit($wizard);
            if (beforeSubmitValue === false) {
              return false;
            }
            return true;
          });
        } else if (thisSettings.debug) {
          console.log('Can\'t make a wizard with only one step oO');
        }
      });
    },
    resizeSteps: function () {
      const activeStepIndex = $('.easyWizardElement').find('.step.active').attr('data-step');
      if ($(window).width() < 991) {
        const width = $(window).width() - 20;
        $('.easyWizardElement').find('.step').css({
          'width': width
        });
        $('.easyWizardElement').find('.easyWizardWrapper').css({
          'margin-left': width * (activeStepIndex - 1) * -1
        });
      } else {
        const width = $('.easyWizardElement').width();
        $('.easyWizardElement').find('.step').css({
          'width': width
        });
        $('.easyWizardElement').find('.easyWizardWrapper').css({
          'margin-left': width * (activeStepIndex - 1) * -1
        });
      }
    },
    prevStep: function () {
      thisSettings = arrSettings[this.index()];
      $activeStep = this.find('.' + thisSettings.stepClassName + '.active');
      if ($activeStep.prev('.' + thisSettings.stepClassName).length) {
        prevStep = parseInt($activeStep.prev().attr('data-step'));
        easyWizardMethods.goToStep.call(this, prevStep);
      }
    },
    nextStep: function () {
      thisSettings = arrSettings[this.index()];
      $activeStep = this.find('.' + thisSettings.stepClassName + '.active');
      if ($activeStep.next('.' + thisSettings.stepClassName).length) {
        nextStep = parseInt($activeStep.next().attr('data-step'));
        easyWizardMethods.goToStep.call(this, nextStep);
      }
    },
    goToStep: function (step) {
      thisSettings = arrSettings[this.index()];
      $activeStep = this.find('.' + thisSettings.stepClassName + '.active');
      $nextStep = this.find('.' + thisSettings.stepClassName + '[data-step="' + step + '"]');
      currentStep = $activeStep.attr('data-step');

      // Prevent sliding same step
      if (currentStep == step) return;

      // Before callBack
      var beforeValue = thisSettings.before(this, $activeStep, $nextStep);
      if (beforeValue === false) {
        return false;
      }

      // Define direction for sliding
      if (currentStep < step) { // forward
        leftValue = thisSettings.width * -1;
      } else { // backward
        leftValue = thisSettings.width;
      }

      let width = $(window).width() < 991 ? $(window).width() - 20 : $(this).width();
      // fix width of all steps
      $('.easyWizardElement').each(function () {
        $('.easyWizardWrapper').find('.step').css({
          'width': $(this).width()
        });
      });

      // Slide !
      $activeStep.removeClass('active');
      $activeStep.find('input, textarea, select, button').attr('tabindex', '-1');

      $nextStep.css('height', '').addClass('active');
      $nextStep.find('input, textarea, select, button').removeAttr('tabindex');

      this.find('.easyWizardWrapper').stop(true, true).animate({
        'margin-left': width * (step - 1) * -1
      }, function () {
        $activeStep.css({ height: '1px' });
      });

      // Defines steps
      if (thisSettings.stepsContainer !== '') {
        $(thisSettings.stepsContainer).find('.easyWizardSteps li').removeClass('current');
        $(thisSettings.stepsContainer).find('.easyWizardSteps li[data-step="' + step + '"]').addClass('current');
      } else {
        this.find('.easyWizardSteps li').removeClass('current');
        this.find('.easyWizardSteps li[data-step="' + step + '"]').addClass('current');
      }

      // Define step title
      if (thisSettings.stepTitleContainer !== '') {
        $(thisSettings.stepTitleContainer).text($nextStep.attr('data-step-title'));
      }

      // Define buttons
      $paginationBloc = this.find('.easyWizardButtons');
      if ($paginationBloc.length) {
        if (step == 1) {
          $paginationBloc.find('.prev, .submit').hide();
          $paginationBloc.find('.next').show();
        } else if (step < thisSettings.steps) {
          $paginationBloc.find('.submit').hide();
          $paginationBloc.find('.prev, .next').show();
        } else {
          if ($nextStep.prev('.' + thisSettings.stepClassName).length) { // If there is a previous step, must be always the case but... you know =)
            $paginationBloc.find('.prev').show();
          }
          $paginationBloc.find('.next').hide();
          $paginationBloc.find('.submit').show();
        }
      }

      // After callBack
      thisSettings.after(this, $activeStep, $nextStep);
    }
  };

  $.fn.easyWizard = function (method) {
    if (easyWizardMethods[method]) {
      return easyWizardMethods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method) {
      return easyWizardMethods.init.apply(this, arguments);
    } else {
      $.error('Method ' + method + ' does not exist on jQuery.easyWizard');
    }
  };
})(jQuery);
